var map = {
	"./corporate_workspaces_solutions/1G Fiber.webp": 9475,
	"./corporate_workspaces_solutions/CORPORATE WORKSPACES1.webp": 4109,
	"./corporate_workspaces_solutions/Corporate Banner.webp": 7786,
	"./corporate_workspaces_solutions/Designed-to-Maximize-Performance.webp": 4742,
	"./corporate_workspaces_solutions/Ethernet cable.webp": 6611,
	"./corporate_workspaces_solutions/Gigabit Level Network Velocity.webp": 5647,
	"./corporate_workspaces_solutions/IPTV.webp": 9154,
	"./corporate_workspaces_solutions/ISP Router.webp": 3128,
	"./corporate_workspaces_solutions/Integration-with-External-Networks.webp": 1684,
	"./corporate_workspaces_solutions/Internet traffic.webp": 8061,
	"./corporate_workspaces_solutions/ONT.webp": 5880,
	"./corporate_workspaces_solutions/Router.webp": 3872,
	"./corporate_workspaces_solutions/Seamlessly-Connected.webp": 5627,
	"./corporate_workspaces_solutions/Splitter.webp": 8662,
	"./corporate_workspaces_solutions/contact banner.webp": 4415,
	"./corporate_workspaces_solutions/olt.webp": 2646,
	"./corporate_workspaces_solutions/telephone.webp": 8691,
	"./corporate_workspaces_solutions/wireless.webp": 9769,
	"./hospitality_solutions/1G Fiber.webp": 4233,
	"./hospitality_solutions/Budgetary-Efficiency.webp": 8134,
	"./hospitality_solutions/Ethernet cable.webp": 9161,
	"./hospitality_solutions/HOSPITALITY1.webp": 2246,
	"./hospitality_solutions/Hospitality Banner.webp": 159,
	"./hospitality_solutions/IPTV.webp": 5316,
	"./hospitality_solutions/ISP Router.webp": 1566,
	"./hospitality_solutions/Internet traffic.webp": 7055,
	"./hospitality_solutions/ONT.webp": 9602,
	"./hospitality_solutions/Router.webp": 4298,
	"./hospitality_solutions/Single-Configuration-Deployment.webp": 7184,
	"./hospitality_solutions/Splitter.webp": 4092,
	"./hospitality_solutions/Structured-Spatial-Layout.webp": 7214,
	"./hospitality_solutions/Triple-Play-Services.webp": 6291,
	"./hospitality_solutions/contact banner.webp": 4749,
	"./hospitality_solutions/olt.webp": 7476,
	"./hospitality_solutions/telephone.webp": 4925,
	"./hospitality_solutions/wireless.webp": 8028,
	"./mobile_banners/corporate_workspaces_solutions/Corporate banner.webp": 165,
	"./mobile_banners/hospitality_solutions/Hosp Banner.webp": 7442,
	"./mobile_banners/student_living_solutions/Student banner.webp": 3192,
	"./student_living_solutions/1G Fiber.webp": 1350,
	"./student_living_solutions/Advanced-Network-Security.webp": 8814,
	"./student_living_solutions/Differentiate Competitively.webp": 3620,
	"./student_living_solutions/Easy-Maintenance.webp": 9472,
	"./student_living_solutions/Ethernet cable.webp": 8402,
	"./student_living_solutions/IPTV.webp": 6199,
	"./student_living_solutions/ISP Router.webp": 9805,
	"./student_living_solutions/Internet traffic.webp": 4488,
	"./student_living_solutions/ONT.webp": 9099,
	"./student_living_solutions/Reliable-Connectivity.webp": 9582,
	"./student_living_solutions/Router.webp": 1909,
	"./student_living_solutions/STUDENT LIVING1.webp": 6347,
	"./student_living_solutions/Splitter.webp": 9479,
	"./student_living_solutions/Student Living Banner.webp": 4074,
	"./student_living_solutions/contact banner.webp": 2186,
	"./student_living_solutions/olt.webp": 2237,
	"./student_living_solutions/telephone.webp": 288,
	"./student_living_solutions/wireless.webp": 6548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7951;